import makeStore from "../../utils/create-store";
import reducer from "./reducer";

export const RESPONSE_LIMIT = 3;

export type GameModuleState = {
    isLoading: boolean,
    game?: GameData
}

const initGameModuleState = {
    isLoading: false,
}

export enum GAME_MODULE_ACTION {
    FETCH,
    FETCH_SUCCESS
}

export type GameModuleAction = {
    type: GAME_MODULE_ACTION,
    payload?: any
}

const [
    GameModuleProvider,
    useGameModuleDispatch,
    useGameModuleState
] = makeStore(reducer, initGameModuleState/*, GAME_MODULE_LS_KEY*/)


export {
    GameModuleProvider,
    useGameModuleDispatch,
    useGameModuleState
}
